import { DESCENDER_RATIO_PER_FONT_SIZE } from '@app/components/TextField/constants';
import { createAbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/libs/createAbsoluteSize';
import { getTextBaseFieldMinimumSize } from '@app/features/apply-react-signing/components/FieldRenderer/libs/getTextBaseFieldMinimumSize';
import { AbsoluteSize } from '@app/features/apply-react-signing/components/FieldRenderer/types';
import PDFFontNormalizer from '@app/libs/reactPdfJs/utils/PDFFontNormalizer';

export function getTextBaseFieldCorrectedSize({
  size,
  fontSize,
  scale,
}: {
  size: AbsoluteSize;
  fontSize: number;
  scale: number;
}) {
  const fontPixelSize: number = PDFFontNormalizer.toPixelFontSize({ fontSize }, scale);

  const descenderHeight = fontPixelSize * DESCENDER_RATIO_PER_FONT_SIZE;
  /**
   * width, height를 "보정"(correct) 해주는 함수.
   *
   * 텍스트 필드의 사이즈는
   *
   * lineHeight: 텍스트 높이
   * textLineCount: 텍스트 높이 개수
   * descenderHeight: 텍스트 하단의 패딩
   *
   * height보정:
   * 텍스트의 높이는 (lineHeight * textLineCount + descenderHeight)여야합니다.
   * 폰트의 크기가 변화했을때, resize가 끝났을 때 해당함수를 호출해 텍스트 박스 높이를 수정해줍니다.
   *
   * width 보정:
   * 최소 넓이를 넘지 못할 경우 최소 넓이로 보정해줍니다.
   */
  const calculateHeight = (totalHeight: number, lineHeight: number) =>
    Math.floor(totalHeight / lineHeight) * lineHeight + descenderHeight;

  const minSize = getTextBaseFieldMinimumSize(fontSize, scale);
  const width = Math.max(size.width, minSize.width);
  const height = Math.max(calculateHeight(size.height, fontPixelSize), minSize.height);

  return createAbsoluteSize({ width, height });
}
